import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { ChatListItem } from './chat-list-item.model';

@Component({
  selector: 'frontend-chat-list',
  templateUrl: 'chat-list.component.html',
  styleUrls: ['chat-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ChatListComponent {
  @Input() staff: ChatListItem[] = [];
  @Output() selectedItem: EventEmitter<ChatListItem> = new EventEmitter();

  onSelectedItem(item: ChatListItem) {
    this.selectedItem.emit(item);
  }
}
